module.exports = __webpack_public_path__ + "img/nat-1.d6c15bf0.jpg";